import React, { Component } from "react";
import AvatarEditor from "react-avatar-editor";
import shortid from "shortid";
import { connect } from "react-redux";
import Ionicon from "react-ionicons";
import FileUpload from "./FileUpload";
import * as actions from "../../../actions/picture";
// todo - IMAGE CROPPER TEMPORARILY TAKEN OUT UNTIL IMPLENMENTATION REDONE WITH NEW LIBRARY AVATAR EDITOR
class CropPicture extends Component {
  constructor() {
    super();
    this.state = {
      img: null,
      newImg: null,
      cropperOpen: false,
      scale: 1,
      rotate: 0
    };
  }

  componentWillMount = () => {
    this.setState({ img: this.props.pictureUrl });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.pictureUrl !== nextProps.pictureUrl) {
      this.setState({ img: nextProps.pictureUrl });
    }
  }

  onChange = e => {
    this.setState({ [e.target.name]: Number(e.target.value) });
  };

  dataURItoBlob = dataURI => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = decodeURI(dataURI.split(",")[1]);

    // separate out the mime component
    let mimeString = dataURI
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];

    // write the bytes of the string to a typed array
    let ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  };

  handleCloseEditor = e => {
    this.setState({
      newImg: null,
      cropperOpen: false
    });
  };

  handleFileChange = dataURI => {
    this.setState({
      newImg: dataURI,
      cropperOpen: true,
      scale: 1,
      rotate: 0
    });
  };

  handleFileSave = () => {
    const { personId, dispatch } = this.props;

    //Old approach
    //const canvas = this.editor.getImage();

    //New approach with classes in CSS, take the canvas 500px x 500px but display it smaller to fit on each device.
    const canvasScaled = this.editor.getImageScaledToCanvas();

    const dataURL = canvasScaled.toDataURL();

    const blob = this.dataURItoBlob(dataURL);
    const file = new File([blob], shortid.generate(), {
      type: "image/jpeg",
      lastModified: Date.now()
    });
    const formData = new FormData(document.forms[0]);
    formData.append("imgUpload", file);
    formData.append("PID", personId);

    dispatch(actions.postPicture(personId, formData));

    this.setState({
      newImg: null,
      cropperOpen: false,
      scale: 1,
      rotate: 0
    });
  };

  setEditorRef = editor => (this.editor = editor);

  render() {
    const { isDefault, guestMode } = this.props;
    return (
      <div
        className="profile-pic"
        style={{ backgroundImage: `url(${this.state.img})` }}
      >
        <div className="profile-edit-picture">
          {/*show when not in guestMode*/}
          {!guestMode && (
            <FileUpload handleFileChange={this.handleFileChange} />
          )}
          {!guestMode && (
            <span>
              <Ionicon icon={isDefault ? "ion-edit" : "ion-edit"} />
            </span>
          )}

          {this.state.cropperOpen && (
            <div className="avatar-cropper">
              <div className="avatar-cropper__component">
                <AvatarEditor
                  ref={this.setEditorRef}
                  image={this.state.newImg}
                  width={500}
                  height={500}
                  border={20}
                  color={[0, 0, 0, 0.6]} // RGBA
                  scale={this.state.scale}
                  rotate={this.state.rotate}
                />
                <div>
                  <small className="text-white">Zoom:</small>
                  <input
                    type="range"
                    step="0.01"
                    min="1"
                    max="2"
                    name="scale"
                    onChange={this.onChange}
                    value={this.state.scale}
                  />
                </div>
                <div>
                  <small className="text-white">Rotate:</small>
                  <input
                    type="range"
                    step="6"
                    min="0"
                    max="360"
                    name="rotate"
                    onChange={this.onChange}
                    value={this.state.rotate}
                  />
                </div>
                <div className="row margin-top">
                  <div className="col-xs-6">
                    <button
                      className="btn btn-secondary"
                      onClick={this.handleCloseEditor}
                    >
                    BACK
                    </button>
                  </div>
                  <div className="col-xs-6">
                    <button
                      className="btn btn-primary"
                      onClick={this.handleFileSave}
                    >
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* crop functionality temp removed unti lnew library working */}

          {/*{this.state.cropperOpen &&*/}
          {/*{     <AvatarCropper*/}
          {/*onRequestHide={this.handleRequestHide}*/}
          {/*cropperOpen={this.state.cropperOpen}*/}
          {/*onCrop={this.handleCrop}*/}
          {/*image={this.state.img}*/}
          {/*width={400}*/}
          {/*height={400} /> } *!/}*/}

          {/* {this.state.cropperOpen && <AvatarEditor
                                 cropperOpen={this.state.cropperOpen}
                                 image={this.state.image}
                                 width={400}
                                 height={400}
                                 border={50}
                                 color={[255, 255, 255, 0.6]} // RGBA
                                 scale={1.2}
                                 rotate={0}
                                 />
                                } */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    pictureUrl:
      props.personId !== parseInt(localStorage.getItem("person_id"), 10)
        ? state.members.otherProfile.picture.url
        : state.profile.picture.url
  };
};

export default connect(mapStateToProps)(CropPicture);



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/header/picture/CropPicture.js